import { useCallback, useMemo } from 'react';
import { TRANSLATIONS, USER_FORM_LISTS } from '../../constants/userFormLists';
import { useCurrentLanguage } from './useCurrentLanguage';
import { LanguageType } from '../../i18n.config';

export const getTranslatedOptions = (listType: keyof typeof TRANSLATIONS, 
items: string[], currentLanguage: LanguageType) => {
  const translations = TRANSLATIONS[listType][currentLanguage];

  return items.map(item => ({
    label: translations[item as keyof typeof translations],
    value: item
  }));
};

export const useTranslations = () => {
  const currentLanguage = useCurrentLanguage();

  const formLists = useMemo(() => {
    const createOptions = (key: keyof typeof USER_FORM_LISTS) => 
      getTranslatedOptions(key, USER_FORM_LISTS[key], currentLanguage);

    return {
      boroughOptions: createOptions('borough'),
      genderOptions: createOptions('gender'),
      ageOptions: createOptions('age'),
      raceOptions: createOptions('race'),
      ethnicityOptions: createOptions('ethnicity'),
      educationOptions: createOptions('education'),
      incomeRangeOptions: createOptions('incomeRange'),
      occupationStatusOptions: createOptions('occupationStatus'),
      professionalExperienceOptions: createOptions('professionalExperience'),
      highGrowthIndustryOptions: createOptions('highGrowthIndustry'),
      areaInterestOptions: createOptions('areaInterest'),
      howYouFoundUsOptions: createOptions('howYouFoundUs'),
      business_start_period: createOptions('business_start_period'),
      mwbe: createOptions('mwbe'),
      employees_count: createOptions('employees_count'),
      business_stage: createOptions('business_stage'),
      important_goal: createOptions('important_goal'),
      business_location: createOptions('business_location'),
      revenue: createOptions('revenue'),
      items_type: createOptions('items_type'),
      three_goals: createOptions('three_goals'),
      advisorCategoriesOptions: createOptions('advisorCategories'),
      categoriesOptions: createOptions('categories'),
      currentIndustryOptions: createOptions('currentIndustry'),
      industriesNycOptions: createOptions('industries_nyc'),
    };
  }, [currentLanguage]);

  const translateSelected = useCallback((listType: keyof typeof TRANSLATIONS, items: string | string[]) => {
    const translations = TRANSLATIONS[listType][currentLanguage];
    return Array.isArray(items)
      ? items.map(item => translations[item as keyof typeof translations] || item)
      : translations[items as keyof typeof translations] || items;
  }, [currentLanguage]);

  return { formLists, translateSelected };
};